import { render } from "./Tour4.vue?vue&type=template&id=a9ac6410"
import script from "./Tour4.vue?vue&type=script&lang=js"
export * from "./Tour4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__